<template>
  <div></div>
</template>

<script>
    import {elements_classes} from '../mixins/elements_classes'

    import $ from 'jquery'

    export default {
        name: "scratch",
        mixins: [elements_classes],
        data(){
            return{
                // this_page: 'scratch'
            }
        },
        computed: {
            this_page(){
                return this.$route.name
            }

        },
        methods: {
            init_scratch_script(){
                let head = document.getElementsByTagName('head')[0];
                let script = document.createElement('script');
                script.onload = ()=>{this.init_scratch()};
                script.type = 'text/javascript';
                script.id = "scratch_src";

                script.src = this.$store.getters.page_address + 'assets/game/scratch/scratch.js';

                head.appendChild(script);
            },
            init_scratch(){
                var scope = this;

                var deviceWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

                var scratchWidth = 480;
                var scratchHeight = 306;
                if(this.$store.state.frontend_mode == true || this.$store.state['instant_win.is_winner']){
                    var scratchImage = "assets/game/scratch/scratch-demo/img/pad-giftcard.png";
                }else{
                    var scratchImage = "assets/game/scratch/scratch-demo/img/sorry.png";
                }

                var scratchImage2 = "assets/game/scratch/scratch-demo/img/scratch-pad.png";

                var scratchSize = 35;  //scratcher size

                if (deviceWidth <= 849)
                {
                    scratchWidth = 300;
                    scratchHeight = 191;


                    if(this.$store.state.frontend_mode == true || this.$store.state['instant_win.is_winner'] ){
                        var scratchImage = "assets/game/scratch/scratch-demo/img/pad-giftcard_small.png";
                    }else{
                        var scratchImage = "assets/game/scratch/scratch-demo/img/sorry-small.png";
                    }

                    var scratchImage2 = "assets/game/scratch/scratch-demo/img/scratch-pad_small.png";
                    var scratchSize = 20;  //scratcher size
                }

                var scratchOptions = {
                    height: scratchHeight,
                    width: scratchWidth,
                    image: scratchImage,
                    image2: scratchImage2,
                    size: scratchSize,
                    scratchDown: function(e, percent){$("#Scratch_percent").html(percent)},
                    scratchUp: function(e, percent){$("#Scratch_percent").html(percent)},
                    scratchMove: (e, percent)=> {
                        if(percent > 70) {

                            this.$router.push({name: this.$store.state.allowed_stages[this.$store.state.allowed_stages.length - 2]})

                        }
                    }
                };

                $("#Scratch").wScratchPad (scratchOptions);

            }
        },
        created(){
          jQuery = $
          this.init_scratch_script()
        },
        mounted(){
            setTimeout(()=>{
                //TODO zamienic na cos związane z redirectem 'allowed_stages' powoduje błąd w FronEndMode
                // this.$router.push({name: this.$store.state.allowed_stages[this.$store.state.allowed_stages.length - 2]})
            },1500)
        }
    }

</script>

<style scoped>

</style>